import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchWinnerPage, type EventWinnerPage } from './useEventWinnersQuery';

/**
 * QA-407 — 전체 당첨자 발표 게시판(이벤트 구분 없이).
 *
 * 이관된 당첨자 글은 BE 가 숨김 캠페인 1개에 모아 두었고(A방안), 그 캠페인은 공개 상세가 404 라 운영자가
 * 어디서 보는지 알기 어려웠다. catalog #59 의 관리자 전체 목록을 쓴다.
 *   GET /admin/v1/events/winners?page(1-base)&size&eventId&keyword — 본문 없음, 노출 예약 전·숨김 글 포함,
 *   글번호 내림차순. keyword 는 제목 부분일치.
 * 본문은 제목을 눌러 수정 팝업을 열 때 admin 단건(fetchEventWinner)으로 받는다.
 */
const ADMIN_ALL = '/admin/v1/events/winners';

export const useAllEventWinnersQuery = (page: number, eventId?: string, keyword?: string, enabled = true) =>
  useQuery<EventWinnerPage>({
    queryKey: ['admin', 'event-winners', 'all', page, eventId ?? '', keyword ?? ''] as const,
    queryFn: () => fetchWinnerPage(ADMIN_ALL, page, { eventId, keyword: keyword?.trim() || undefined }),
    placeholderData: keepPreviousData,
    enabled,
  });
